@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.image {
  margin-top: spacers.getSpacer(s) !important;
  margin-bottom: 0 !important;

  &--small {
    @media (min-width: map.get($grid-breakpoints, lg)) {
      margin-top: 0 !important;
    }
  }

  &__wrapper {
    position: relative;
  }

  &__img {
    display: block;
    width: 100%;
  }

  &__copyright {
    position: absolute;
    right: spacers.getSpacer(2xs);
    bottom: spacers.getSpacer(2xs);
    margin: 0;
    padding: 0 spacers.getSpacer(3xs);
    background: rgb(255 255 255 / 80%);
    font-size: spacers.getSpacer(xs);
    line-height: 130%;
  }
}
